var scratcherTileTemplate = require('./scratcher-search-results.handlebars');
var { getUrlParameterByName } = require('./../../shared/scripts/UrlParameterHelper');
var scratcherService = new scratcherService();

$(function () {

    if (!$('#scratcher-search').length) return;

    var $modalBtnApplyFilter = $('#scratcher-search-filter-modal #modal-apply-filters'),
        $btnApplyFilter = $('#scratcher-search #apply-filters'),
        $allPriceFiltersOption = $('#scratcher-search #price-filters input[name="allPriceFilters"]').parent(),
        $priceFilterOptions = $('#scratcher-search #price-filters input[name="priceFilter"]').parent(),
        $modalPriceFilterOptions = $('#scratcher-search-filter-modal #modal-price-filters input[name="priceFilter"]').parent(),
        $modalAllPriceFiltersOption = $('#scratcher-search-filter-modal #modal-price-filters input[name="allPriceFilters"]').parent(),
        $modal = $('#scratcher-search-filter-modal');

    //Initialize
    scratcherService.options.pageSize = $('#page-size').val();
    scratcherService.options.filters = getScratcherFilterValues();

    //Try to set initial filter values from query string values
    setInitialFiltersFromUrl();

    getScratchers();

    //Events
    $modalBtnApplyFilter.on('click', function (e) {
        $modal.modal('hide');
        scratcherService.options.page = 0;
        scratcherService.options.filters = getScratcherFilterValues(true);
        getScratchers();
        syncScratcherFilterValues();
        updateAppliedScratcherFilterDisplay();
    });

    $btnApplyFilter.on('click', function (e) {
        scratcherService.options.page = 0;		
        scratcherService.options.filters = getScratcherFilterValues();
        getScratchers();
        syncScratcherFilterValues();
        updateAppliedScratcherFilterDisplay();
    });

    $allPriceFiltersOption.on('click', function (e) {
        handleScratcherPriceFilterClick(e);
    });
    $modalAllPriceFiltersOption.on('click', function (e) {
        handleScratcherModalPriceFilterClick(e);
    });
    $priceFilterOptions.on('click', function (e) {
        handleScratcherPriceFilterClick(e);
    });
    $modalPriceFilterOptions.on('click', function (e) {
        handleScratcherModalPriceFilterClick(e);
    });

    $modal.on('show.bs.modal', function () {
        scratcherService.options.filters = getScratcherFilterValues();
        syncScratcherFilterValues();
    });
    $modal.on('hide.bs.modal', function () {
        scratcherService.options.filters = getScratcherFilterValues(true);
        syncScratcherFilterValues();
    });


    $('.scratcher-pager button#pager-previous').on('click', function () {
        (scratcherService.options.page > 0) ? scratcherService.options.page-- : scratcherService.options.page = 0;
        getScratchers();
    });

    $('.scratcher-pager button#pager-next').on('click', function () {
        scratcherService.options.page++;
        getScratchers();
    });

    $('.scratcher-pager a').on('click', function () {
        scratcherService.options.page = $(this).data('page');
        getScratchers();
    });

});

function handleScratcherPriceFilterClick(e) {
    var targetName = $(e.target).find('input')[0].name,
        targetValue = $(e.target).find('input').val(),
        allPrices = $('#price-filters input[name="allPriceFilters"]'),
        allPricesIsChecked = $('#price-filters input[name="allPriceFilters"]:checked').parent().hasClass('active'),
        priceFilters = $('#price-filters input[name="priceFilter"]:checked'),
        currentlySelectedFilters = getScratcherFilterValues();

    //allprices is clicked and is currently NOT 'active'
    //does nothing if allprices is already 'active'
    if (targetName === "allPriceFilters") {

        if (allPricesIsChecked) {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        //toggle allprices will be set to 'active'
        //uncheck all others that are checked
        priceFilters.parent().button('toggle');
    }

    //any priceFilter is clicked and allPrices is currently 'active'
    //does nothing if allprices is NOT 'active'
    if (targetName === "priceFilter") {
        //set allprices to NOT 'active'
        if (allPricesIsChecked) {
            allPrices.parent().button('toggle');
            return;
        }

        var index = currentlySelectedFilters.prices.indexOf(targetValue);
        if (index > -1) {
            currentlySelectedFilters.prices.splice(index, 1);
            if (!currentlySelectedFilters.prices.length) {
                allPrices.parent().button('toggle');
            }
        }
    }

};

function handleScratcherModalPriceFilterClick(e) {
    var targetName = $(e.target).find('input')[0].name,
        targetValue = $(e.target).find('input').val(),
        allPrices = $('#modal-price-filters input[name="allPriceFilters"]'),
        allPricesIsChecked = $('#modal-price-filters input[name="allPriceFilters"]:checked').parent().hasClass('active'),
        priceFilters = $('#modal-price-filters input[name="priceFilter"]:checked'),
        currentlySelectedFilters = getScratcherFilterValues(true);

    //allprices is clicked and is currently NOT 'active'
    //does nothing if allprices is already 'active'
    if (targetName === "allPriceFilters") {

        if (allPricesIsChecked) {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        //toggle allprices will be set to 'active'
        //uncheck all others that are checked
        priceFilters.parent().button('toggle');
    }

    //any priceFilter is clicked and allPrices is currently 'active'
    //does nothing if allprices is NOT 'active'
    if (targetName === "priceFilter") {
        //set allprices to NOT 'active'
        if (allPricesIsChecked) {
            allPrices.parent().button('toggle');
            return;
        }

        var index = currentlySelectedFilters.prices.indexOf(targetValue);
        if (index > -1) {
            currentlySelectedFilters.prices.splice(index, 1);
            if (!currentlySelectedFilters.prices.length) {
                allPrices.parent().button('toggle');
            }
        }
    }

};

function getScratchers() {

    unbindScratcherTileEvents();

    $.ajax({
        url: '/api/v1/scratchers',
        type: 'POST',
        data: scratcherService.options,
        dataType: 'json'
    })
        .done(function (data) {			
            var html = scratcherTileTemplate({ scratchers: data.data });
            $('#scratcher-tiles').html(html);

            scratcherService.options.totalPages = data.totalPages;
            scratcherService.options.page = data.currentPage;
            bindScratcherTileEvents();
            console.log("total pages: "+ data.totalPages);
        if(data.totalPages>1) {
            $('.scratcher-pager').show()
            updateScratcherPager();
        }else{
        $('.scratcher-pager').hide()
        }
 });
}

function getScratcherFilterValues(fromModal) {
    var $priceContainer,
        $categoryContainer;

    if (fromModal) {
        $priceContainer = $('#modal-price-filters');
        $categoryContainer = $('#modal-category-filter');
    }
    else {
        $priceContainer = $('#price-filters');
        $categoryContainer = $('#category-filter');
    }

    return {
        prices: getPrices($priceContainer),
        categories: getCategories($categoryContainer)
    };

    function getPrices($container) {
        return $container
            .find(".btn.active input:checkbox:not([name='allPriceFilters']):checked")
            .map(function () { return this.value; })
            .get();
    }

    function getCategories($container) {
        return $container
            .find('.btn.active input[type=radio]')
            .map(function () { return this.value; })
            .get()
    }
}

function syncScratcherFilterValues() {
    //Reset all selected (checkbox) filters
    $('#scratcher-search #price-filters .btn').removeClass('active focus');
    $('#scratcher-search-filter-modal #modal-price-filters .btn').removeClass('active focus');

    scratcherService.options.filters.categories.forEach(function (x) {
        $('#scratcher-search #category-filter input[type=radio]#' + x)
            .parent()
            .button('toggle');
        $('#scratcher-search-filter-modal #modal-category-filter input[type=radio]#' + x)
            .parent()
            .button('toggle');
    });

    if (!scratcherService.options.filters.prices.length) {
        var $allPrices = $('#price-filters input[name="allPriceFilters"]').parent();
        var $modalAllPrices = $('#modal-price-filters input[name="allPriceFilters"]').parent();

        if (!$allPrices.hasClass('active')) {
            $allPrices.button('toggle');
        }
        if (!$modalAllPrices.hasClass('active')) {
            $modalAllPrices.button('toggle');
        }
    }

    scratcherService.options.filters.prices.forEach(function (x) {
        $('#scratcher-search #price-filters input[type=checkbox][value="' + x + '"]')
            .parent()
            .button('toggle');
        $('#scratcher-search-filter-modal #modal-price-filters input[type=checkbox][value="' + x + '"]')
            .parent()
            .button('toggle');
    });
}

function bindScratcherTileEvents() {
    var $tiles = $('.scratcher-tile');

    //Set initial tile-left background
    $tiles.each(function () {
        var $tile = $(this);
        var imageUrl = $tile.data('image-url');
        if (imageUrl) {
            hoverBackground($tile, imageUrl);
        }
    });

       $tiles.on('mouseleave', function () {
			//$tiles.on('mouseenter', function () {
        var $tile = $(this);
        var imageUrl = $tile.data('image-url');
        if (imageUrl) {
            hoverBackground($tile, imageUrl);
        }
    });
    $tiles.on('mouseenter', function () {
	//$tiles.on('mouseleave', function () {
        var $tile = $(this);
        var imageUrl = $tile.data('image-url');
        if (imageUrl) {
            initialBackground($tile, imageUrl);
        }
    });

    function initialBackground($tile, imageUrl) {
        var $tileLeft = $tile.find('.tile-left');
        $tileLeft.css('background', '');
        var defaultBackgroundColor = $tileLeft.css('background-color');
        $tileLeft.css({
            "background": "linear-gradient(0deg, " + defaultBackgroundColor + ", " + defaultBackgroundColor + "), url(" + imageUrl + ")",
            "background-size": "cover"
        });
        $tileLeft.children().css("color", "");
    }
    function hoverBackground($tile, imageUrl) {
        var $tileLeft = $tile.find('.tile-left');
        $tileLeft.css({
            "background": "linear-gradient(0deg, transparent, transparent), url(" + imageUrl + ")",
            "background-size": "cover"
        });
        $tileLeft.children().css("color", "transparent");
    }
}

function unbindScratcherTileEvents() {
    $(".scratcher-tile").off("mouseenter mouseleave");
}

function updateAppliedScratcherFilterDisplay() {
    var filterCount = [].concat(scratcherService.options.filters.categories, scratcherService.options.filters.prices).length;
    $('.applied-filters-display').text(filterCount);
    /*----To Update URL----*/
    var updatedPage=location.href?location.href.split('?')[0]:location.href;
    
   if(scratcherService.options.filters.prices.length){ 
       let prices=scratcherService.options.filters.prices.join(",");
       updatedPage=updatedPage+'?price='+prices;
    }
    
    if(scratcherService.options.filters.categories.length){ 
        let categories=scratcherService.options.filters.categories.join(",");
        updatedPage=updatedPage+(scratcherService.options.filters.prices.length?'&':'?')+'category='+categories;
     }
     
     window.history.replaceState(null, null, updatedPage);
}

function updateScratcherPager() {

    //Hide all pages
    $('.scratcher-pager a')
        .parent()
        .addClass('hide');

    //Show all pages less than current page
    $('.scratcher-pager a')
        .filter(function () {
            return $(this).data('page') < scratcherService.options.totalPages;
        })
        .parent()
        .removeClass('hide');

    //Remove all active page
    $('.scratcher-pager a').removeClass('active');

    //make current page active
    $('.scratcher-pager a[data-page=' + scratcherService.options.page + ']').addClass('active');

    //Handle next page button
    (scratcherService.options.page + 1 < scratcherService.options.totalPages)
        ? $('.scratcher-pager #pager-next').prop("disabled", false)
        : $('.scratcher-pager #pager-next').prop("disabled", true);

    //Handle previous page button
    (scratcherService.options.page > 0)
        ? $('.scratcher-pager #pager-previous').prop("disabled", false)
        : $('.scratcher-pager #pager-previous').prop("disabled", true);
}

function setInitialFiltersFromUrl() {
    var qsCategory = getUrlParameterByName('category', window.location.search);
    var qsPrice = getUrlParameterByName('price', window.location.search, true);

    if (!qsCategory && !qsPrice)
        return;

    if (qsCategory) {
        scratcherService.options.filters.categories = [];
        scratcherService.options.filters.categories.push(qsCategory);
    }

    if (qsPrice) {
        if (qsPrice.length > 1) {
            qsPrice.forEach((x) => {
                scratcherService.options.filters.prices.push(x);
            });
        } else {
            scratcherService.options.filters.prices.push(qsPrice);
        }
    }
    syncScratcherFilterValues();
}

function scratcherService(options) {

    var scratcherSearchDefaultOptions = {
        page: 0,
        totalPages: 0,
        pageSize: 14,
        filters: {
            prices: [],
            categories: []
        }
    };

    this.options = $.extend(true, scratcherSearchDefaultOptions, options);
}


// WEBPACK FOOTER //
// ./features/scratchers/scratcher-search.js